import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import { ErrorBoundary } from 'react-error-boundary'
import Layout from './components/Layout'
import Home from './pages/Home'
import BlogPost from './components/BlogPost'
import AuthorPage from './components/AuthorPage'
import Donar from './pages/Donar'
import Equipo from './pages/Equipo'
import Historia from './pages/Historia'
import Blog from './pages/Blog'
import Authors from './pages/Authors'
import ScrollToTop from './components/ScrollToTop'
import Inscripciones from './pages/Inscripciones'
import Servicios from './pages/Servicios'
import SeParte from './pages/se-parte'

function ErrorFallback({ error, resetErrorBoundary }: { error: Error, resetErrorBoundary: () => void }) {
  return (
    <div style={{ 
      padding: '20px', 
      backgroundColor: '#ffeaa7', 
      border: '2px solid #fdcb6e',
      borderRadius: '8px',
      margin: '20px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h2 style={{ color: '#e17055', marginBottom: '10px' }}>
        🚨 Something went wrong in the app
      </h2>
      <details style={{ whiteSpace: 'pre-wrap', fontSize: '14px', marginBottom: '15px' }}>
        <summary>Error details:</summary>
        {error.message}
        <br />
        {error.stack}
      </details>
      <button 
        onClick={resetErrorBoundary}
        style={{
          backgroundColor: '#00b894',
          color: 'white',
          border: 'none',
          padding: '10px 20px',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Try again
      </button>
    </div>
  )
}

function SafeApp() {

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Router>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/autor" element={<Authors />} />
            <Route path="/autor/:slug" element={<AuthorPage />} />
            <Route path="/nosotros/equipo" element={<Equipo />} />
            <Route path="/nosotros/historia" element={<Historia />} />
            <Route path="/donar" element={<Donar />} />
            <Route path="/inscripciones" element={<Inscripciones />} />
            <Route path="/servicios" element={<Servicios />} />
            <Route path="/se-parte" element={<SeParte />} />  
          </Routes>
        </Layout>
        <Analytics />
      </Router>
    </ErrorBoundary>
  )
}

export default SafeApp